const getCiceroStyleElement = () => {
  const styleItems = document.querySelectorAll('head style');
  for (const item of styleItems) {
    if (item.textContent.indexOf('.cfsAppTooltip') > -1) {
      return item;
    }
  }
};

const whenStyleElementIsAppended = () => {
  return new Promise((resolve) => {
    const waitForCiceroStyleElementToBeAppended = () => {
      setTimeout(() => {
        const item = getCiceroStyleElement();
        if (item) {
          return resolve(item);
        }
        return waitForCiceroStyleElementToBeAppended();
      }, 10);
    };
    waitForCiceroStyleElementToBeAppended();
  });
};

const fixCssMediaQueries = () => {
  whenStyleElementIsAppended().then((styleElement) => {
    // A bit of a hack: Change media queries of cicero style to match engine's breakpoints
    styleElement.textContent = styleElement.textContent.replace(/@media\s?\(min-width:900px\)/g, '@media (min-width:1010px)');
  });
};

export { fixCssMediaQueries };
